import {saveAs} from "file-saver";
import {apiClient} from "../api/client";

const decodeFilename = (value) => {
    try {
        return decodeURIComponent(value);
    } catch (_error) {
        return value;
    }
};

const fallbackFilename = (value) => {
    if (typeof value === "string" && value.trim()) return value.trim();
    return `download-${Number(value) || "file"}`;
};

const sanitizeFilename = (value, fallbackName) => {
    if (typeof value !== "string") return fallbackFilename(fallbackName);
    const pathParts = value.replace(/\\/g, "/").split("/");
    const basename = Array.from(pathParts[pathParts.length - 1], (character) => {
        const code = character.codePointAt(0);
        return code <= 31 || code === 127 ? " " : character;
    })
        .join("")
        .replace(/\s+/g, " ")
        .trim()
        .slice(0, 180);
    return !basename || basename === "." || basename === ".." ? fallbackFilename(fallbackName) : basename;
};

export const filenameFromDisposition = (disposition, fallbackName) => {
    if (!disposition) return fallbackFilename(fallbackName);
    const encodedMatch = String(disposition).match(/filename\*\s*=\s*([^;]+)/i);
    if (encodedMatch) {
        const encodedValue = encodedMatch[1].trim().replace(/^"|"$/g, "");
        const encodedParts = encodedValue.match(/^[^']*'[^']*'(.*)$/);
        return sanitizeFilename(decodeFilename(encodedParts ? encodedParts[1] : encodedValue), fallbackName);
    }
    const quotedMatch = String(disposition).match(/filename\s*=\s*"([^"]*)"/i);
    if (quotedMatch) return sanitizeFilename(quotedMatch[1], fallbackName);
    const plainMatch = String(disposition).match(/filename\s*=\s*([^;]+)/i);
    return sanitizeFilename(plainMatch ? plainMatch[1].trim() : null, fallbackName);
};

const readHeader = (headers, name) => {
    if (!headers) return null;
    if (typeof headers.get === "function") {
        const value = headers.get(name);
        if (value !== undefined && value !== null) return String(value);
    }
    const key = Object.keys(headers).find((header) => header.toLowerCase() === name.toLowerCase());
    return key ? String(headers[key]) : null;
};

export const downloadAuthenticatedFile = async ({url, fallbackName}) => {
    const response = await apiClient.get(url, {responseType: "blob"});
    const filename = filenameFromDisposition(
        readHeader(response.headers, "content-disposition"),
        fallbackName,
    );
    saveAs(response.data, filename);
    return {blob: response.data, filename};
};
